// extracted by mini-css-extract-plugin
module.exports = {"secondaryHeader":"secondaryHeader_secondaryHeader__CebRK","secondaryHeaderLink":"secondaryHeader_secondaryHeaderLink__Jj_Ah","activeMenu":"secondaryHeader_activeMenu__q_XVb"};